import React, { useState, useEffect } from "react";
import "./sidebar.css";
import { Group, Event, Logout } from "@mui/icons-material";
import CampaignIcon from "@mui/icons-material/Campaign";
import { useNavigate, useLocation } from "react-router-dom";

export default function Sidebar({ onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("anuncios");

  // Detect active tab from current route
  useEffect(() => {
    if (location.pathname.includes("clases")) {
      setActiveTab("clases");
    } else if (location.pathname.includes("miembros")) {
      setActiveTab("miembros");
    } else {
      setActiveTab("anuncios");
    }
  }, [location]);

  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };

  const handleLogout = () => {
    navigate("/");
    onLogout?.();
  };

  return (
    <aside className="sidebar">
      <div className="logoSection">
        <img src="./logoIglesiaWhite.svg" alt="logo" className="sidebarLogo" />
      </div>

      <nav className="sidebarNav">
        <ul>
          <li
            className={activeTab === "anuncios" ? "active" : ""}
            onClick={() => handleTabClick("anuncios", "/dashboard")}
          >
            <CampaignIcon className="sidebarIcon" />
            <span>Anuncios</span>
          </li>

          <li
            className={activeTab === "clases" ? "active" : ""}
            onClick={() => handleTabClick("clases", "/clases")}
          >
            <Event className="sidebarIcon" />
            <span>Clases Bíblicas</span>
          </li>

          <li
            className={activeTab === "miembros" ? "active" : ""}
            onClick={() => handleTabClick("miembros", "/miembros")}
          >
            <Group className="sidebarIcon" />
            <span>Miembros</span>
          </li>
        </ul>
      </nav>

      <div className="sidebarLogout" onClick={handleLogout}>
        <Logout className="sidebarIcon" />
        <span>Cerrar sesión</span>
      </div>
    </aside>
  );
}
